export const AVAILABLE_TODAY = 'Available Today'
export const AVAILABLE_TOMORROW = 'Available Tomorrow'
export const AVAILABLE_BY_DATE = 'Available by'
export const CONTACT_STORE_TEXT = 'Need it sooner? Call us.'
export const CALL_STORE_TEXT = 'Call store for availability'
